module.exports = __webpack_public_path__ + "static/media/logo-pet.1ed6d028.svg";